module.exports = __webpack_public_path__ + "static/media/googleCloudMlb.2209f397.gif";